import React from 'react';
import PropTypes from 'prop-types';

const CountryFlag = ({ countryCode, size = 'sm' }) => {
  // Size configurations
  const sizeConfig = {
    'xs': { 
      width: '16px', 
      height: '12px'
    },
    'sm': { 
      width: '20px', 
      height: '15px'
    },
    'md': { 
      width: '24px', 
      height: '18px'
    },
    'lg': { 
      width: '32px', 
      height: '24px'
    }
  };
  
  const currentSize = sizeConfig[size] || sizeConfig['sm'];

  // Use flag-icons from public/flag-icons-main/flags/1x1/
  const flagSrc = `/flag-icons-main/flags/1x1/${countryCode.toLowerCase()}.svg`;

    // Fallback for unsupported countries
  const handleImageError = (e) => {
    e.target.style.display = 'none';
    e.target.nextSibling.style.display = 'inline-flex';
  };

  return (
    <div style={{ display: 'inline-block', position: 'relative' }}>
    <img 
      src={flagSrc}
      alt={`${countryCode} flag`}
      style={{
        width: currentSize.width,
        height: currentSize.height,
        display: 'inline-block',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        border: '1px solid rgba(255,255,255,0.2)',
        objectFit: 'cover'
      }}
      title={`${countryCode} flag`}
        onError={handleImageError}
    />
      {/* Fallback element */}
      <div 
        style={{
          width: currentSize.width,
          height: currentSize.height,
          display: 'none',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '4px',
          border: '1px solid rgba(255,255,255,0.2)',
          backgroundColor: 'rgba(255,255,255,0.1)',
          fontSize: '10px',
          color: 'white',
          position: 'absolute',
          top: 0,
          left: 0
        }}
        title={`${countryCode} flag`}
      >
        {countryCode}
      </div>
    </div>
  );
};

CountryFlag.propTypes = {
  countryCode: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg'])
};

export default CountryFlag; 